module.exports = __webpack_public_path__ + "static/media/carousel_direct.01efc3be.svg";